import { createStyles, Group, Stack } from '@mantine/core';
import { Text, Title } from '@repo/foundations';
import { EntityIcon } from '../EntityIcon/EntityIcon';
import type { LineageFlowNode } from '../EntityNode/EntityNode.types';
import { ENTITY_NODE_HEADER_INTEGRATION_ICON_SIZE } from '../EntityNodeHeader/EntityNodeHeader.constants';

interface ActionBarSearchResultProps {
	result: LineageFlowNode;
	navigateToNode: (nodeID: string) => void;
}

const useStyles = createStyles((theme) => ({
	wrapper: {
		cursor: 'pointer',
		width: theme.other.width.md,
		padding: `${theme.spacing.sm} ${theme.spacing.md}`,
		borderRadius: theme.radius.md,
		gap: theme.spacing.xs,
		flexWrap: 'nowrap',
		'&:hover': {
			backgroundColor: theme.other.getColor('surface/primary/hover'),
		},
		'&:active': {
			backgroundColor: theme.other.getColor('surface/primary/active'),
		},
	},
	content: {
		width: `calc(${theme.other.width.md}px - ${ENTITY_NODE_HEADER_INTEGRATION_ICON_SIZE}px - (2 * ${theme.spacing.md}) - ${theme.spacing.xs})`,
	},
}));

function ActionBarSearchResult({
	result,
	navigateToNode,
}: ActionBarSearchResultProps) {
	const { classes } = useStyles();

	const handleOnClick = () => {
		navigateToNode(result.id);
	};

	return (
		<Group className={classes.wrapper} onClick={handleOnClick}>
			<EntityIcon
				entityType={result.data.entity_type}
				integrationType={result.data.integration_type ?? undefined}
			/>
			<Stack className={classes.content} spacing={0}>
				<Title size="sm" truncate>
					{result.data.title}
				</Title>
				<Text size="xs" color="text/secondary/default">
					{result.data.subtitle}
				</Text>
			</Stack>
		</Group>
	);
}

export default ActionBarSearchResult;
